import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[#FFD537]/50 focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "bg-gradient-to-r from-[#FFD537]/20 to-[#F9B438]/20 text-[#1D1D1B] border border-[#FFD537]/30",
        secondary:
          "bg-neutral-100 text-neutral-700 border border-neutral-200",
        destructive:
          "bg-red-100 text-red-700 border border-red-200",
        success:
          "bg-green-100 text-green-700 border border-green-200",
        warning:
          "bg-amber-100 text-amber-700 border border-amber-200",
        outline: 
          "border-2 border-neutral-200 text-[#1D1D1B] bg-white",
        dark:
          "bg-[#1D1D1B] text-white border border-[#1D1D1B]",
        gold:
          "bg-gradient-to-r from-[#FFD537] to-[#F9B438] text-[#1D1D1B] border-none shadow-sm",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
